module.exports = __webpack_public_path__ + "img/m_online_shopping_icon_01.png";